import { makeFamilyRoot, transformCommonElementsResponse, transformElementsResponse, transformMaterialsResponse, transformOptionsResponse, transformServerMaterialsResponse } from './api-helpers';
import { CartAPI, ConfigElementInfo, GetBasketResponse, LoginResponse, PricingRequest, PricingResponse, RestoreSessionResponse } from './types/api-types';


// TODO remove this ones
const CART_PROGRAM = 'SC101_001R';
const MATERIALS_PROGRAM = 'CONF102R';
const CFG_USER_PROGRAM = 'USER100R';
const CFG_BASKET_PROGRAM = 'CONF500R';

const API2 = import.meta.env.VITE_API2;
const DATA_ASSET_BASE = import.meta.env.VITE_API;
const PROGRAM_ENDPOINT = API2 + '/cfgwebsrv.pgm';

export async function appLogin(user: string|undefined, password: string|undefined, 
                               language: string|undefined, country: string|undefined, 
                               mode: 'anonymous' | 'user'|'dealer'): Promise<LoginResponse> {
    const apiURL = new URL(PROGRAM_ENDPOINT);
    const params = new URLSearchParams();
    params.append('program', 'USER100R');
    params.append('action', 'logon');
    params.append('mode', mode);
    if(user) {
        params.append('user', user);
    }
    if(password) {
        params.append('password', password);
    }
    if(language) {
        params.append('language', language);
    }
    if(country) {
        params.append('country', country);
    }

    const response = await fetch(apiURL.toString(), {
        method: 'POST',
        body: params
    });
    const result = await response.json();
    if(result.error) {
        throw new Error(result.error);
    }
    return result;
}



export async function restoreSession(sessionId: string): Promise<RestoreSessionResponse> {
    const searchParams = new URLSearchParams();
    searchParams.append('program', CFG_USER_PROGRAM);
    searchParams.append('action', 'getsessiondata')
    searchParams.append('sessionid', sessionId);
    const response = await programJsonGet(searchParams);
    return response;
}

export async function setActiveCurrency(currency: string, sessionId: string): Promise<void> {
    const apiURL = new URL(PROGRAM_ENDPOINT);
    const formData = new FormData();
    formData.append('program', CFG_USER_PROGRAM);
    formData.append('action', 'setactivecurrency');
    formData.append('currency', currency);
    formData.append('sessionid', sessionId);

    const response = await fetch(apiURL.toString(), {
        method: 'POST',
        body: formData
    });
    const result = await response.json();
    if(result.error) {
        throw new Error(result.error);
    }
    return result;
}


// Generates the PDF

export async function uploadImage(image: Blob, sessionId: string): Promise<void> {
    const apiURL = new URL(API2 + '/jrcfgpic2.pgm');
    const file = new File([image], `${sessionId}.jpg`, { type: 'image/jpg' });
    const formData = new FormData();
    const fileName = `${sessionId}.jpg`;
    //formData.append('sessionid', sessionId);
    formData.append('type', 'preview');
    //formData.append('filename', fileName);
    formData.append('browserfile', file, fileName);
    const response = await fetch(apiURL.toString(), {
        method: 'POST',
        body: formData
    });
    const result = await response.json();
    if(!result.success) {
        throw new Error(result.errmsg);
    }
}

export async function uploadImageAlt(image: Blob, sessionId: string): Promise<void> {
    const apiURL = new URL(PROGRAM_ENDPOINT);
    const file = new File([image], `${sessionId}.jpg`, { type: 'image/jpg' });
    const formData = new FormData();
    const fileName = `${sessionId}.jpg`;
    formData.append('sessionid', sessionId);
    formData.append('program', 'CONF100R');
    formData.append('action', 'savepicture');
    formData.append('type', 'jpg');
    formData.append('filename', fileName);
    formData.append('browserfile', file, fileName);
    const response = await fetch(apiURL.toString(), {
        method: 'POST',
        body: formData
    });
    const result = await response.json();
    if(!result.SUCCESS) {
        throw new Error(result.errmsg);
    }
}

export async function uploadCartImage(image: Blob, cartId: number, sessionId: string): Promise<void> {
    const apiURL = new URL(PROGRAM_ENDPOINT);
    const file = new File([image], `${sessionId}.jpg`, { type: 'image/jpg' });
    const formData = new FormData();
    const fileName = `${sessionId}.jpg`;
    formData.append('sessionid', sessionId);
    formData.append('program', 'CONF100R');
    formData.append('action', 'saveshoppingcartpicture');
    formData.append('shoppingcartid', cartId.toString());
    formData.append('type', 'jpg');
    formData.append('filename', fileName);
    formData.append('browserfile', file, fileName);
    const response = await fetch(apiURL.toString(), {
        method: 'POST',
        body: formData
    });
    const result = await response.json();
    if(!result.SUCCESS) {
        throw new Error(result.errmsg);
    }
}

export async function generatePDF(language: string, sessionId: string): Promise<string|null> {
    const apiURL = new URL(PROGRAM_ENDPOINT);
    apiURL.searchParams.append('program', 'CONF100R');
    apiURL.searchParams.append('action', 'getpdf');
    apiURL.searchParams.append('language', language);
    apiURL.searchParams.append('sessionid', sessionId);
    const response = await fetch(apiURL.toString());
    const asJSON = await response.json();
    if(asJSON.SUCCESS) {
        return asJSON.pdf;
    } else {
        return null;
    }
}

export async function touchPricing(request: PricingRequest): Promise<PricingResponse> {
    const formData = makePricingRequestParams(request);
    return (await fetch(import.meta.env.VITE_API2 + '/cfgwebsrv.pgm', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: formData
    })).json();
}

export function makePricingRequestParams(request: PricingRequest): URLSearchParams {
    const formData = new URLSearchParams();
    formData.append('program', 'CONF100R');
    formData.append('action', 'getconfigprice');
    formData.append('language', request.config2.language);
    if(request.config2.sessionid) {
        formData.append('sessionid', request.config2.sessionid);
    }
    formData.append('config', JSON.stringify({
        family: request.config.family,
        options: request.config.options,
        elements: request.config.elements.map(elementAdapter)
    }));
    formData.append('config2', JSON.stringify({
        family: request.config2.family,
        language: request.config2.language,
        sessionid: request.config2.sessionid,
        elementgroups: request.config2.elementgroups.map(g => {
            return {
                id: g.id,
                options: g.options,
                elements: g.elements.map(elementAdapter)
            }
        }),        
    }));
    formData.append('state', JSON.stringify(request.state));
    return formData;
}

// ==== Catalog ====

// all this section is duplicated from the first API in api-slice.
// the reason is that for the 3D basket is needed, but in ahother
// way of consuming this same data.


export async function getCommonElements(lang: string) {
    const data = await dataAssetGet('/elements.json');
    return transformCommonElementsResponse(data, lang);
}

export async function getCommonParts() {
    return dataAssetGet('/parts.json');
}

export async function getMaterials(lang: string) {
    const data = await dataAssetGet('/materials.json');
    return transformMaterialsResponse(data, lang);
}

export async function getServerMaterials(lang: string, sessionId: string) {

    const formData = new URLSearchParams();
    formData.append('program', MATERIALS_PROGRAM);
    formData.append('sessionid', sessionId);

    const data = await programJsonGet(formData);
    return transformServerMaterialsResponse(data, lang);
}

export async function getOptions(family: string, variant: string|undefined, lang: string) {
    const familyFileRoot = makeFamilyRoot(family, variant);
    const data = await dataAssetGet(`/${familyFileRoot}.options.json`);
    return transformOptionsResponse(data, lang);
}

export async function getElements(family: string, variant: string|undefined, lang: string) {
    const familyFileRoot = makeFamilyRoot(family, variant);
    const data = await dataAssetGet(`/${familyFileRoot}.elements.json`);
    return transformElementsResponse(data, lang);
}

export async function getParts(family: string, variant: string|undefined) {
    const familyFileRoot = makeFamilyRoot(family, variant);
    return dataAssetGet(`/${familyFileRoot}.parts.json`);
}


// ==== basket: carts ====

export async function getCustomerCarts(sessionId: string) {

    const formData = new URLSearchParams();
    formData.append('program', CFG_BASKET_PROGRAM);
    formData.append('action', 'listconfigusershoppingcarts');
    formData.append('sessionid', sessionId);

    return programJsonGet(formData);

}

export async function deleteCart(cartId: number, sessionId: string) {

    const formData = new URLSearchParams();
    formData.append('program', CFG_BASKET_PROGRAM);
    formData.append('action', 'deleteshoppingcart');
    formData.append('shoppingcartid', cartId.toString());
    formData.append('sessionid', sessionId);

    
    return programJsonPost(formData);

}

export async function getShoppingCart(cartId: number, sessionId: string): Promise<CartAPI> {

    const formData = new URLSearchParams();
    formData.append('program', CFG_BASKET_PROGRAM);
    formData.append('action', 'getshoppingcart');
    formData.append('shoppingcartid', cartId.toString());
    formData.append('sessionid', sessionId);

    return programJsonGet(formData);

}

export async function getShoppingCartByCode(code: string, sessionId: string): Promise<CartAPI> {

    const formData = new URLSearchParams();
    formData.append('program', CFG_BASKET_PROGRAM);
    formData.append('action', 'getshoppingcart');
    formData.append('shoppingcartcode', code);
    formData.append('sessionid', sessionId);

    return programJsonGet(formData);

}

export async function updateCartNameAndDescription(cartId: number, name: string, description: string, sessionId: string) {

    const formData = new URLSearchParams();
    formData.append('program', CFG_BASKET_PROGRAM);
    formData.append('action', 'updateshoppingcartdescriptions');
    formData.append('shoppingcartid', cartId.toString());
    formData.append('shoppingcartname', name);
    formData.append('shoppingcartdescription', description);
    formData.append('sessionid', sessionId);

    return programJsonPost(formData);
}


export async function printCart(cartId: number, sessionId: string) {

    const formData = new URLSearchParams();

    formData.append('program', CFG_BASKET_PROGRAM);
    formData.append('action', 'printshoppingcartbasket');
    formData.append('shoppingcartid', cartId.toString());
    formData.append('sessionid', sessionId);

    return programJsonPost(formData);
}

export async function saveCartState(cartId: number, state: any, sessionId: string) {
    const formData = new URLSearchParams();

    formData.append('program', CFG_BASKET_PROGRAM);
    formData.append('action', 'updateshoppingcartstate');
    formData.append('shoppingcartid', cartId.toString());
    formData.append('state', JSON.stringify(state));
    formData.append('sessionId', sessionId);

    return programJsonPost(formData);
}


// ==== basket: baskets ====

export async function getCartBaskets(cartId: number, sessionId: string) {

    const formData = new URLSearchParams();
    formData.append('program', CFG_BASKET_PROGRAM);
    formData.append('action', 'listshoppingcartbaskets ');
    formData.append('shoppingcartid', cartId.toString());
    formData.append('sessionid', sessionId);

    return programJsonGet(formData);
}

export async function deleteBasket(basketId: number, sessionId: string) {

    const formData = new URLSearchParams();
    formData.append('program', CFG_BASKET_PROGRAM);
    formData.append('action', 'deleteshoppingbasket');
    formData.append('shoppingbasketid', basketId.toString());
    formData.append('sessionid', sessionId);

    
    return programJsonPost(formData);

}

export async function createCart(sessionId: string): Promise<number|undefined> {
    
    const formData = new URLSearchParams();
    formData.append('program', CFG_BASKET_PROGRAM);
    formData.append('action', 'addshoppingbasket');
    formData.append('sessionid', sessionId);

    const result = await programJsonPost(formData);
    if(result.SUCCESS) {
        return result.addedshoppingcartID;
    } else {
        return undefined;
    }

}

export async function addBasketToCart(cartId: number|undefined, sessionId: string): Promise<{ cartId: number|undefined, basketId: number}|undefined> {
    
    const formData = new URLSearchParams();
    formData.append('program', CFG_BASKET_PROGRAM);
    formData.append('action', 'addshoppingbasket');
    if(cartId) {
        formData.append('shoppingcartid', cartId.toString());
    }
    formData.append('sessionid', sessionId);

    const result = await programJsonPost(formData);
    if(result.SUCCESS) {
        return {
            cartId: result.addedshoppingcartID,
            basketId: result.addedshoppingbasketID
        }
    } else {
        return undefined;
    }

}

export async function getBasket(shoppingBasketId: number, sessionId: string): Promise<GetBasketResponse> {

    const formData = new URLSearchParams();
    formData.append('program', CFG_BASKET_PROGRAM);
    formData.append('action', 'getshoppingbasket');
    formData.append('shoppingbasketid', shoppingBasketId.toString());
    formData.append('sessionid', sessionId);

    return programJsonGet(formData);
}

export async function getBasketByCode(shoppingBasketCode: string, sessionId: string): Promise<GetBasketResponse> {

    const formData = new URLSearchParams();
    formData.append('program', CFG_BASKET_PROGRAM);
    formData.append('action', 'getshoppingbasket');
    formData.append('shoppingbasketcode', shoppingBasketCode);
    formData.append('sessionid', sessionId);

    return programJsonGet(formData);
}

export async function updateBasketFromConfiguration(shoppingCartId: number, shoppingBasketId: number, sessionId: string): Promise<GetBasketResponse> {

    const formData = new URLSearchParams();
    formData.append('program', CFG_BASKET_PROGRAM);
    formData.append('action', 'updateshoppingbasket');
    formData.append('shoppingcartid', shoppingCartId.toString());
    formData.append('shoppingbasketid', shoppingBasketId.toString());
    formData.append('sessionid', sessionId);

    return programJsonPost(formData);
}

export async function updateBasketQuantity(cartId: number, basketId: number, quantity: number, sessionId: string) {
    
    const formData = new URLSearchParams();
    formData.append('program', 'CONF500R');
    formData.append('action', 'updateshoppingbasketquantity');
    formData.append('shoppingcartid', cartId.toString());
    formData.append('shoppingbasketid', basketId.toString());
    formData.append('shoppingbasketquantity', quantity.toString());
    formData.append('sessionid', sessionId);

    return programJsonPost(formData);

}

export async function startNewShoppingBasket(cartId: number, sessionId: string) {

    const formData = new URLSearchParams();
    formData.append('program', CFG_BASKET_PROGRAM);
    formData.append('action', 'startnewshoppingbasket');
    formData.append('shoppingcartid', cartId.toString());
    formData.append('sessionid', sessionId);

    return programJsonPost(formData);
}

// ==== basket: basket lines and components ====

export async function getBasketLines(shoppingBasketId: string, sessionId: string) {

    const formData = new URLSearchParams();
    formData.append('program', CFG_BASKET_PROGRAM);
    formData.append('action', 'listshoppingbasketlines');
    formData.append('shoppingbasketid', shoppingBasketId);
    formData.append('sessionid', sessionId);

    return programJsonGet(formData);
}

export async function getBasketLineComponents(shoppingBasketLineId: string, sessionId: string) {

    const formData = new URLSearchParams();
    formData.append('program', CFG_BASKET_PROGRAM);
    formData.append('action', 'listshoppingbasketlinecomponents');
    formData.append('shoppingbasketlineid', shoppingBasketLineId);
    formData.append('sessionid', sessionId);
    
    return programJsonGet(formData);
}



// ==== Pending or wrong ====

//https://www.jori.com/joricfgp/cfgwebsrv.pgm?program=CONF500R&sessionid=00B4D7CF-2CC7-455A-9FA5-75847C67DFF5&action=updateshoppingbasketdescriptions&shoppingbasketid=93&shoppingbasketname=ronny&shoppingbasketdescription=mijneerstebasket


export async function setCustomerCart(cartId: number, sessionId: string) {

    const formData = new URLSearchParams();
    formData.append('program', 'CONF100R');
    formData.append('action', 'setCustBasket');
    formData.append('mandid', cartId.toString());
    formData.append('session', sessionId);

    return (await fetch(PROGRAM_ENDPOINT, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body:formData
    }))

}

export async function addShoppingCart(sessionId: string) {

    const formData = new URLSearchParams();
    formData.append('program', CART_PROGRAM);
    formData.append('action', 'add1shoppingcart');
    formData.append('sessionid', sessionId);

    const response = await fetch(PROGRAM_ENDPOINT, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body:formData
    });
    return response.json();
}


// ==== misc ====

export async function sendSalesParameters(sessionId: string, params: Record<string, string | number>) {

    const formData = new URLSearchParams();
    formData.append('program', 'CONF101R');
    formData.append('action', 'sendvkparameters');    
    formData.append('sessionid', sessionId);
    for(const entry of Object.entries(params)) {
        formData.append(entry[0], entry[1].toString());
    }

    return programJsonPost(formData);
}




// ==== helpers ====

async function programJsonGet(formData: URLSearchParams) {
    const result = await fetch(PROGRAM_ENDPOINT + '?' + formData.toString(), {
        method: 'GET'
    });
    return result.json();
}


async function programJsonPost(formData: URLSearchParams) {
    const result = await fetch(PROGRAM_ENDPOINT, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body:formData
    });
    return result.json();
}

async function dataAssetGet(fileName: string) {
    const result = await fetch(DATA_ASSET_BASE + fileName, {
        method: 'GET'
    });
    return result.json();
}

async function colorProgramGet() {
    const result = await fetch(PROGRAM_ENDPOINT, {
        method: 'GET'
    });
    return result.json();
}

function elementAdapter(e: ConfigElementInfo): any {
    return {
        ...e,
        parts: e.parts.map(p => {
            return {
                ...p,
                data: dataAdapter(p.data)
            }
        }),
        data: dataAdapter(e.data)
    }
}

function dataAdapter(data: any): any {
    if(Array.isArray(data)) {
        const result = [];
        for(const item of data) {
            for(const datafieldid of Object.getOwnPropertyNames(item)) {
                result.push({
                    datafieldid,
                    datafieldvalue: item[datafieldid]
                })
            }
        }
        return result;
    } else if(typeof data === 'object') {
        const result = [];
        for(const datafieldid of Object.getOwnPropertyNames(data)) {
            result.push({
                datafieldid,
                datafieldvalue: data[datafieldid]
            })
        }
        return result;
    } else {
        return data;
    }
}